/** What players see of the narrator voices (names and one-line descriptions); the briefs stay in src/voices.ts,
 *  on the server. */
/** The voices players can choose (owner, 2026-10-18; Wry, Tender, Brisk and Chorus 2026-10-20); the others stay in the
 *  lab. Classic remains on older stories. */
export const PLAYER_VOICES = ["inward", "spare", "fable", "noir", "wry", "tender", "brisk", "chorus"] as const;
export type PlayerVoice = (typeof PLAYER_VOICES)[number];
/** How each voice is described to players (Account settings, the story map). */
export const VOICE_BLURBS: Record<PlayerVoice | "classic", string> = {
  inward: "Attentive and literary: long sentences that follow what you notice.",
  spare: "Minimal: short lines, white space, what isn't said.",
  fable: "A teller's cadence: plain words, old shapes, the strange as law.",
  noir: "Hard and terse: short sentences, dry wit, a world that pushes back.",
  wry: "Dry and observant: quietly funny about how people behave.",
  tender: "Close and warm: people first, much of it in their own words.",
  brisk: "Momentum: verbs, clear space, something you could do right now.",
  chorus: "The place's own talk: rumours, sayings, who is related to whom.",
  classic: "Weftwake's first narrator, from before voices.",
};

export const VOICE_NAMES: Record<PlayerVoice | "classic", string> = {
  inward: "Inward", spare: "Spare", fable: "Fable", noir: "Noir", wry: "Wry", tender: "Tender", brisk: "Brisk", chorus: "Chorus", classic: "Classic",
};
